import { render, staticRenderFns } from "./ProfileActivator.vue?vue&type=template&id=0456713e&scoped=true&lang=pug"
import script from "./ProfileActivator.vue?vue&type=script&lang=js"
export * from "./ProfileActivator.vue?vue&type=script&lang=js"
import style0 from "./ProfileActivator.vue?vue&type=style&index=0&id=0456713e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0456713e",
  null
  
)

export default component.exports